import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

export interface SharedChartData {
  totalUsers?: any;
  usersCategory?: any;
  usersDevice?: any;
  audiencePublic?: any;
  audienceTreemap?: any;
  filters?: any;
  timestamp?: number;
}

export interface LoadingState {
  public: boolean;
  personas: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SharedDataService {
  private publicDataSubject = new BehaviorSubject<SharedChartData | null>(null);
  private loadingStateSubject = new BehaviorSubject<LoadingState>({ public: false, personas: false });

  // Observable streams
  public publicData$ = this.publicDataSubject.asObservable();
  public loadingState$ = this.loadingStateSubject.asObservable();

  constructor() {}

  /**
   * Store public data for sharing with personas
   */
  setPublicData(data: SharedChartData): void {
    this.publicDataSubject.next({
      ...data,
      timestamp: Date.now()
    });
  }

  /**
   * Get stored public data
   */
  getPublicData(): SharedChartData | null {
    return this.publicDataSubject.value;
  }

  /**
   * Check if public data is available and recent (within last 5 minutes)
   */
  hasFreshPublicData(): boolean {
    const data = this.publicDataSubject.value;
    if (!data || !data.timestamp) return false;

    const fiveMinutes = 5 * 60 * 1000;
    return (Date.now() - data.timestamp) < fiveMinutes;
  }

  /**
   * Clear stored data
   */
  clearData(): void {
    this.publicDataSubject.next(null);
  }

  /**
   * Set loading state for a component
   */
  setLoading(component: 'public' | 'personas', isLoading: boolean): void {
    const currentState = this.loadingStateSubject.value;
    this.loadingStateSubject.next({
      ...currentState,
      [component]: isLoading
    });
  }

  /**
   * Check if any component is loading
   */
  isAnyLoading(): boolean {
    const state = this.loadingStateSubject.value;
    return state.public || state.personas;
  }

  /**
   * Get current loading state
   */
  getLoadingState(): LoadingState {
    return this.loadingStateSubject.value;
  }
}
